import dashboard from "./dashboard";
import campaigns from "./campaigns";
import creatives from "./creatives";
import contextualBundles from "./contextual-bundles";
import filters from "./filters";
import statistics from "./statistics";
import payments from "./payments";
import settings from "./settings";
// import trafficCalculator from "./traffic-calculator";
// import audience from "./audience";
import faq from "./faq";
import rules from "./rules";

const AdvertLayout = () =>
  import(/* webpackChunkName: "advert" */ "@/layouts/advert/AdvertLayout.vue");

const advertLayout = [
  {
    path: "/",
    name: "AdvertLayout",
    component: AdvertLayout,
    redirect: { name: "Campaigns" },
    children: [
      ...dashboard,
      ...campaigns,
      ...creatives,
      ...contextualBundles,
      ...filters,
      ...statistics,
      ...payments,
      ...settings,
      // ...trafficCalculator, // NOTE: https://spalah-advertising.atlassian.net/browse/BAS-1267
      // ...audience, // NOTE: https://spalah-advertising.atlassian.net/browse/BAS-1361
      ...faq,
      ...rules,
    ],
  },
];

export default advertLayout;
